import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYERS = [{
  name: 'Linda',
  location: 'Nashville, TN',
  timeAgo: '2 min ago'
}, {
  name: 'Carol',
  location: 'Toronto, ON',
  timeAgo: '4 min ago'
}, {
  name: 'Susan',
  location: 'Portland, OR',
  timeAgo: '6 min ago'
}, {
  name: 'Patricia',
  location: 'Austin, TX',
  timeAgo: '8 min ago'
}, {
  name: 'Barbara',
  location: 'Calgary, AB',
  timeAgo: '11 min ago'
}, {
  name: 'Margaret',
  location: 'Boise, ID',
  timeAgo: '13 min ago'
}, {
  name: 'Dorothy',
  location: 'Tampa, FL',
  timeAgo: '15 min ago'
}, {
  name: 'Janet',
  location: 'Denver, CO',
  timeAgo: '18 min ago'
}, {
  name: 'Diane',
  location: 'Raleigh, NC',
  timeAgo: '21 min ago'
}, {
  name: 'Sharon',
  location: 'Vancouver, BC',
  timeAgo: '24 min ago'
}, {
  name: 'Nancy',
  location: 'Phoenix, AZ',
  timeAgo: '27 min ago'
}, {
  name: 'Betty',
  location: 'San Diego, CA',
  timeAgo: '30 min ago'
}];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrentIndex(prev => (prev + 1) % BUYERS.length);
    setIsVisible(true);
    // Hide after 4.5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4500);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    // Initial delay before first toast
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
      // Hide first one after 4.5s
      setTimeout(() => setIsVisible(false), 4500);
    }, 5000);
    // Then cycle every 10 seconds
    const interval = setInterval(showNext, 10000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [dismissed, showNext]);
  const buyer = BUYERS[currentIndex];
  if (dismissed) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-[320px]" data-id="element-239">
      <AnimatePresence data-id="element-240">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-white rounded-2xl shadow-lg shadow-charcoal/8 border border-stone-100 p-3.5 flex items-start gap-3 relative" data-id="element-241">
            {/* Icon */}
            <div className="w-10 h-10 bg-coral/10 rounded-xl flex items-center justify-center shrink-0" data-id="element-242">
              <ShoppingBag className="w-5 h-5 text-coral" data-id="element-243" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-244">
              <p className="text-charcoal text-sm font-medium leading-snug" data-id="element-245">
                <span className="font-bold" data-id="element-246">{buyer.name}</span>{' '}
                <span className="text-warm-gray" data-id="element-247">from</span>{' '}
                <span className="font-semibold" data-id="element-248">{buyer.location}</span>
              </p>
              <p className="text-warm-gray text-xs mt-0.5" data-id="element-249">
                just purchased Memory Tickets
              </p>
              <div className="flex items-center gap-1.5 mt-1.5" data-id="element-250">
                <span className="relative flex h-2 w-2" data-id="element-251">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-252"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-253"></span>
                </span>
                <span className="text-[11px] text-warm-gray/70" data-id="element-254">
                  {buyer.timeAgo}
                </span>
              </div>
            </div>

            {/* Dismiss */}
            <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full text-warm-gray/40 hover:text-warm-gray hover:bg-stone-100 transition-colors text-xs" aria-label="Dismiss" data-id="element-255">
              ✕
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}